import { AnimationIcon } from "@dmm-com/rocket-web-ui-library";
import { memo, useRef, useState } from "react";
import * as Styled from "./style";
import type { SampleViewerModalProps } from "~/components/blocks/product/common/video-legacy-season/sample-viewer-modal";

export const MobileModalBody = memo(({ gravureSeasonImageData, selectedSampleImageIndex }: SampleViewerModalProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const onLoaded = () => setIsLoaded(true);
  return (
    <>
      <Styled.DivSpWrapper ref={ref}>
        {gravureSeasonImageData.map((data, idx) => {
          const onLoad = () => {
            if (idx !== selectedSampleImageIndex) return;
            const nodes = ref.current;
            if (nodes === null) return;
            const targetElement = nodes.childNodes[selectedSampleImageIndex] as HTMLImageElement;
            targetElement.scrollIntoView();
            onLoaded();
          };
          return (
            <Styled.ImgGravure
              key={idx}
              src={data.imageLarge || data.image}
              onLoad={onLoad}
              onError={onLoaded}
              alt={`グラビア画像-${idx}`}
              isLoaded={isLoaded}
            />
          );
        })}
      </Styled.DivSpWrapper>
      {!isLoaded && (
        <Styled.LoadingWrapper>
          <AnimationIcon name="loading" iconSize="XXXL" iconColor="GRAY900" />
        </Styled.LoadingWrapper>
      )}
    </>
  );
});

MobileModalBody.displayName = "MobileModalBody";
